/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";

import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import Cookies from "js-cookie";

import "firebase/auth";

import {
  AppBar,
  Button,
  Toolbar,
  colors,
  Select,
  MenuItem,
  FormControl,
  Box,
  Typography,
  IconButton,
  Menu,
} from "@material-ui/core";

import InputIcon from "@material-ui/icons/Input";

import ContactsIcon from "@material-ui/icons/Contacts";

import axios from "utils/axios";
import useRouter from "utils/useRouter";

import logOutCompletely from "utils/logOutCompletely";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { get } from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "none",
  },
  flexGrow: {
    flexGrow: 1,
  },
  logo: {
    width: "170px",
    height: "36px",
  },
  search: {
    backgroundColor: "rgba(255,255,255, 0.1)",
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: "flex",
    alignItems: "center",
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: "inherit",
  },
  searchInput: {
    flexGrow: 1,
    color: "inherit",
    "& input::placeholder": {
      opacity: 1,
      color: "inherit",
    },
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100,
  },
  searchPopperContent: {
    marginTop: theme.spacing(1),
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    "&:hover": {
      backgroundColor: colors.green[900],
    },
  },
  trialIcon: {
    marginRight: theme.spacing(1),
  },
  notificationsButton: {
    marginLeft: theme.spacing(1),
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600],
  },
  logoutButton: {
    marginLeft: theme.spacing(2),
  },
  contactButton: {
    marginLeft: theme.spacing(2),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
  customerName: {
    color: "white",
  },
  topBarSelect: {
    "& .MuiSvgIcon-root": {
      color: "white !important",
    },
  },
  MuiSelectIcon: {
    color: "white !important",
  },
  menuFormControl: {
    color: "white",
    textDecoration: "none",
    "& .MuiSelect-icon": {
      color: "white",
      textDecoration: "none",
      border: "none",
    },
    width: "200px",
  },
  menuSelect: {
    color: "white",
    textDecoration: "none",
    "& .MuiSelect-icon": {
      color: "white",
      textDecoration: "none",
      border: "none",
    },
  },
  customerEmail: {
    marginLeft: theme.spacing(3),
    color: "white",
  },
  emailAddress: {
    color: "white",
  },
}));

const TopBar = (props) => {
  const { onOpenNavBarMobile, onTopBarLoaded, className, ...rest } = props;

  const classes = useStyles();
  const { history } = useRouter();
  const searchRef = useRef(null);
  const dispatch = useDispatch();

  const [customerName, setCustomerName] = useState(
    Cookies.get("customer_name")
  );
  const [customerId, setCustomerId] = useState(Cookies.get("customer_id"));

  const [customerData, setCustomerData] = useState();
  const [menuData, setMenuData] = useState();
  const [citysparkOrgsBelongsTo, setCitysparkOrgsBelongsTo] = useState();
  const [bestOfOrgsBelongsTo, setBestOfOrgsBelongsTo] = useState();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleLogout = async () => {
    await logOutCompletely();
  };

  const router = useRouter();

  const assignUserLevelsAndRouteToProperPath = (
    citysparkOrgsBelongsTo,
    bestOfOrgsBelongsTo,
    currentCustomerId
  ) => {
    if (Cookies.get("super_admin") == "true") {
      return;
    } else {
      let currentBestOfCustomer = bestOfOrgsBelongsTo.find(
        (data) => data._id == currentCustomerId
      );
      let currentCustomerCitysparkId =
        currentBestOfCustomer &&
        currentBestOfCustomer.subscription &&
        currentBestOfCustomer.subscription.business_registration &&
        currentBestOfCustomer.subscription.business_registration.cityspark_id;
      let currentCitysparkCustomer = citysparkOrgsBelongsTo.find(
        (data) => data.id == currentCustomerCitysparkId
      );
      let accessBestOfLevel =
        currentCitysparkCustomer && currentCitysparkCustomer.accessBestOfLevel;
      let accessPhotoLevel =
        currentCitysparkCustomer && currentCitysparkCustomer.accessPhotoLevel;

      Cookies.set("bestofuserlevel", accessBestOfLevel);
      Cookies.set("bestofphotouserlevel", accessPhotoLevel);
      if (accessBestOfLevel > 0) {
        window.location.href = window.location.origin + "/ballots";
      } else if (accessPhotoLevel > 0) {
        window.location.href = window.location.origin + "/photo-ballots";
      } else {
        window.location.href = window.location.origin + "/error-privilages";
      }
    }
  };

  const handleChange = (event) => {
    Cookies.set(
      "parent_customer_id",
      Cookies.get("parent_customer_id") || Cookies.get("member_id")
    );

    Cookies.set(
      "parent_bestofuseracct",
      Cookies.get("parent_bestofuseracct") || Cookies.get("bestofuseracct")
    );

    let customerId = event.target.value;

    let tempData = menuData.find((data) => data.customer_id == customerId);

    Cookies.set("customer_id", customerId);
    Cookies.set("customer_name", tempData && tempData.name);
    Cookies.set("customer_slug", tempData && tempData.customer_slug);
    setCustomerName(tempData && tempData.name);
    assignUserLevelsAndRouteToProperPath(
      citysparkOrgsBelongsTo,
      bestOfOrgsBelongsTo,
      customerId
    );
  };

  const getAllOrgsBelongsTo = async (acct) => {
    try {
      if (Cookies.get("findOrgsBelongsToCalled") == "true") {
        let output = localStorage.getItem("findOrgsBelongsToOutput");
        if (output) {
          return JSON.parse(output);
        }
      } else {
        let axios_path_to =
          process.env.REACT_APP_BACK_END_SERVER_URL +
          "/server/v1/cityspark_customers/findOrgsBelongsTo";
        const payload = {
          acct:
            Cookies.get("parent_bestofuseracct") ||
            Cookies.get("bestofuseracct"),
        };
        const response = await axios.post(axios_path_to, payload);
        localStorage.removeItem("findOrgsBelongsToOutput");
        localStorage.setItem(
          "findOrgsBelongsToOutput",
          JSON.stringify(response.data)
        );
        Cookies.set("findOrgsBelongsToCalled", "true", { expires: 1 });

        return response.data;
      }
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
  };
  const getBestOfOrgsBelongsTo = async (citysparkOrgsBelongsTo) => {
    try {
      if (Cookies.get("findBestOfOrgsBelongsToCalled") == "true") {
        let output = localStorage.getItem("findBestOfOrgsBelongsToOutput");
        if (output) {
          return JSON.parse(output);
        }
      } else {
        let axios_path_to =
          process.env.REACT_APP_BACK_END_SERVER_URL +
          "/server/v1/cityspark_customers/findBestOfOrgsBelongsToBasedOnCitysparkOrgs";
        const payload = {
          cityspark_orgs_belongs_to: citysparkOrgsBelongsTo,
        };
        const response = await axios.post(axios_path_to, payload);
        localStorage.removeItem("findBestOfOrgsBelongsToOutput");
        localStorage.setItem(
          "findBestOfOrgsBelongsToOutput",
          JSON.stringify(response.data)
        );
        Cookies.set("findBestOfOrgsBelongsToCalled", "true", { expires: 1 });

        return response.data;
      }
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const assignUserLevels = (
    citysparkOrgsBelongsTo,
    bestOfOrgsBelongsTo,
    currentCustomerId
  ) => {
    if (Cookies.get("super_admin") == "true") {
      return;
    } else {
      let currentBestOfCustomer = bestOfOrgsBelongsTo.find(
        (data) => data._id == currentCustomerId
      );
      let currentCustomerCitysparkId =
        currentBestOfCustomer &&
        currentBestOfCustomer.subscription &&
        currentBestOfCustomer.subscription.business_registration &&
        currentBestOfCustomer.subscription.business_registration.cityspark_id;
      let currentCitysparkCustomer = citysparkOrgsBelongsTo.find(
        (data) => data.id == currentCustomerCitysparkId
      );
      let accessBestOfLevel =
        currentCitysparkCustomer && currentCitysparkCustomer.accessBestOfLevel;
      let accessPhotoLevel =
        currentCitysparkCustomer && currentCitysparkCustomer.accessPhotoLevel;

      Cookies.set("bestofuserlevel", accessBestOfLevel);
      Cookies.set("bestofphotouserlevel", accessPhotoLevel);
    }
  };

  const assignAllData = async () => {
    let tempArray = [];

    let acct = Cookies.get("bestofuseracct");

    let citysparkOrgsBelongsTo = await getAllOrgsBelongsTo(acct);
    setCitysparkOrgsBelongsTo(citysparkOrgsBelongsTo);

    if (citysparkOrgsBelongsTo && citysparkOrgsBelongsTo.length > 0) {
      let bestOfOrgsBelongsTo = await getBestOfOrgsBelongsTo(
        citysparkOrgsBelongsTo
      );
      setBestOfOrgsBelongsTo(bestOfOrgsBelongsTo);
      let currentCustomerId = Cookies.get("customer_id");

      assignUserLevels(
        citysparkOrgsBelongsTo,
        bestOfOrgsBelongsTo,
        currentCustomerId
      );
      if (bestOfOrgsBelongsTo && bestOfOrgsBelongsTo.length > 0) {
        bestOfOrgsBelongsTo.map((data) => {
          let tempObj = {
            name: data.name,
            customer_id: data._id,
            customer_slug: data.slug,
          };
          tempArray.push(tempObj);
        });

        setMenuData(tempArray);
      }
      onTopBarLoaded(true);
    } else {
      setMenuData(tempArray);
      onTopBarLoaded(true);
    }
  };
  useEffect(() => {
    assignAllData();
  }, []);

  const handleContact = () => {
    try {
      window.Intercom("show");
    } catch (error) {
      console.log("contact error", error);
    }
  };
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const getCorrectRoleName = () => {
    let userRole = Cookies.get("member_role");

    if (Cookies.get("super_admin") == "true") {
      return "Admin";
    } else if (userRole == "owner") {
      return "Manager";
    } else if (userRole == "accountExecutive") {
      return "Agent-BestOf";
    } else if (userRole == "adRep") {
      return "Ad-Rep";
    } else {
      return "No Role Assigned";
    }
  };
  const getCorrectBestOfPlanName = () => {
    let bestOfUserLevel = Cookies.get("bestofuserlevel");
    if (bestOfUserLevel == "0") {
      return "No Access";
    } else if (bestOfUserLevel == "1") {
      return "Standard";
    } else if (bestOfUserLevel == "2") {
      return "Premium";
    } else {
      return "No Plan Assigned";
    }
  };
  const getCorrectPhotoPlanName = () => {
    let bestOfPhotoUserLevel = Cookies.get("bestofphotouserlevel");
    if (bestOfPhotoUserLevel == "0") {
      return "No Access";
    } else if (bestOfPhotoUserLevel == "1") {
      return "Standard";
    } else if (bestOfPhotoUserLevel == "2") {
      return "Premium";
    } else {
      return "No Plan Assigned";
    }
  };

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="secondary"
    >
      {window.location.pathname.indexOf("/create-ad") < 0 &&
        window.location.pathname.indexOf("/edit-profile-link") < 0 &&
        window.location.pathname.indexOf("/multi-create-ad") < 0 &&
        window.location.pathname.indexOf("/create-group-ad") < 0 &&
        window.location.pathname.indexOf("/multi-create-group-ad") < 0 &&
        window.location.pathname.indexOf(
          "/create-winners-upgraded-listing-ad"
        ) < 0 &&
        window.location.pathname.indexOf("/multi-create-winners-ad") < 0 &&
        window.location.pathname.indexOf("/multi-create-winners-group-ad") <
          0 && (
          <>
            {" "}
            <Toolbar>
              <RouterLink to="/">
                <img
                  alt="Logo"
                  className={classes.logo}
                  src="/images/logos/Logo_WhiteSmall.png"
                />
              </RouterLink>
              <div className={classes.flexGrow} />

              {Cookies.get("super_admin") != "true" && (
                <>
                  <FormControl className={classes.menuFormControl}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={customerId}
                      onChange={handleChange}
                      displayEmpty
                      className={classes.menuSelect}
                      variant="standard"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Removes border
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none", // No border on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none", // No border when focused
                        },
                      }}
                      inputProps={{
                        sx: {
                          borderBottom: "none !important", // Removes bottom underline
                        },
                      }}
                    >
                      {menuData &&
                        menuData.map((data) => (
                          <MenuItem
                            value={data.customer_id}
                            className={classes.menuCustomerName}
                          >
                            {data.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </>
              )}
              <Button
                className={classes.contactButton}
                color="inherit"
                onClick={handleContact}
              >
                <ContactsIcon className={classes.contactIcon} />
                Contact
              </Button>
              {/* <Button
                className={classes.logoutButton}
                color="inherit"
                onClick={handleLogout}
              >
                <InputIcon className={classes.logoutIcon} />
                Email address
              </Button> */}
              {/* <Button className={classes.logoutButton} color="inherit">
                <InputIcon className={classes.logoutIcon} />
                Email address
              </Button> */}
              <Box
                display="flex"
                alignItems="center"
                className={classes.customerEmail}
              >
                <Typography className={classes.emailAddress}>
                  {Cookies.get("customer_email")}
                </Typography>

                <IconButton onClick={handleClick} style={{ color: "white" }}>
                  <ArrowDropDownIcon />
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem style={{ pointerEvents: "none" }}>
                    Account:{" "}
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        paddingLeft: "5px",
                      }}
                    >
                      {Cookies.get("customer_name")}
                    </span>
                  </MenuItem>
                  <MenuItem style={{ pointerEvents: "none" }}>
                    Role:{" "}
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        paddingLeft: "5px",
                      }}
                    >
                      {getCorrectRoleName()}
                    </span>
                  </MenuItem>
                  <MenuItem style={{ pointerEvents: "none" }}>
                    Best Of plan:{" "}
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        paddingLeft: "5px",
                      }}
                    >
                      {getCorrectBestOfPlanName()}
                    </span>
                  </MenuItem>
                  <MenuItem style={{ pointerEvents: "none" }}>
                    Photo plan:{" "}
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        paddingLeft: "5px",
                      }}
                    >
                      {getCorrectPhotoPlanName()}
                    </span>
                  </MenuItem>

                  <MenuItem
                    onClick={handleLogout}
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      textAlign: "center",
                      display: "block",
                      width: "100%",
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </Box>
            </Toolbar>
          </>
        )}
    </AppBar>
  );
};

export default TopBar;
